import { FeatureFlag } from '../FeatureFlag';

export const useTradingGateway = new FeatureFlag({
    key: 'use-trading-gateway',
    defaultValue: false,
});
